import React, { useCallback, useEffect, useState } from "react";
import { AuthService } from "../services/AuthService";

export interface UserInfo {
  id: string;
  email: string;
  name: string;
  jiraApiToken?: string;
  githubApiToken?: string;
}

interface SessionContextShape {
  user: UserInfo | null;
  loading: boolean;
  signin: (user: UserInfo) => void;
  signout: () => void;
}

const noop = () => {};

export const SessionContext = React.createContext<SessionContextShape>({
  user: null,
  loading: true,
  signin: noop,
  signout: noop,
});

interface SessionProviderProps {
  children?: {};
}

export const SessionProvider: React.FC<SessionProviderProps> = ({ children }) => {
  const [user, setUser] = useState<UserInfo | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const signin = useCallback((u: UserInfo) => {
    setUser(u);
  }, []);

  const signout = useCallback(() => {
    AuthService.signout()
      .catch(() => {})
      .finally(() => {
        setUser(null);
        window.location.href = "/login";
      });
  }, []);

  useEffect(() => {
    AuthService.current()
      .then((u) => setUser(u))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  return (
    <SessionContext.Provider value={{ user, loading, signin, signout }}>
      {children}
    </SessionContext.Provider>
  );
};
